import PortfolioScreen from "app/screens/residents/show/PortfolioScreen";

export default function ResidentPortfolioPage() {
  return <PortfolioScreen />;
}
